<template>
    <div v-if="!showLocation" class="nettdoc-bodyparts">
        <div class="nettdoc-bodyparts__head-side">
            <div class="nettdoc-bodyparts__head-side--wrapper" @click="showDetails('sideface')" :class="[model && model.some(entry => entry.includes('sideface_')) ? 'nettdoc-bodyparts__is-active' : 'nettdoc-bodyparts__frame', preview ? 'nettdoc-preview' : '']">
                <SymptomLocationSideFace v-on:show="showDetails('sideface')" :choice="model" :active="false" :preview="preview" />
            </div>
        </div>
        <div class="nettdoc-bodyparts__head-normal">
            <div class="nettdoc-bodyparts__head-normal--wrapper" @click="showDetails('normalface')" :class="[model && model.some(entry => entry.includes('frontface_')) ? 'nettdoc-bodyparts__is-active' : 'nettdoc-bodyparts__frame', preview ? 'nettdoc-preview' : '']">
              <SymptomLocationFrontFace v-on:show="showDetails('normalface')" :choice="model" :active="false" :preview="preview" />
            </div>
        </div>
        <div class="nettdoc-bodyparts__body-front">
          <div class="nettdoc-bodyparts__head-normal--wrapper" @click="showDetails('bodyfront')" :class="[model && model.some(entry => entry.includes('frontbody_')) ? 'nettdoc-bodyparts__is-active' : 'nettdoc-bodyparts__frame', preview ? 'nettdoc-preview' : '']">
            <SymptomLocationFrontBody v-on:show="showDetails('bodyfront')" :choice="model" :active="false" :preview="preview" />
          </div>
        </div>
        <div class="nettdoc-bodyparts__body-back">
          <div class="nettdoc-bodyparts__head-normal--wrapper" @click="showDetails('bodyback')" :class="[model && model.some(entry => entry.includes('backbody_')) ? 'nettdoc-bodyparts__is-active' : 'nettdoc-bodyparts__frame', preview ? 'nettdoc-preview' : '']">
            <SymptomLocationBackBody v-on:show="showDetails('bodyback')" :choice="model" :active="false" :preview="preview" />
          </div>    
        </div>
    </div>
    <SymptomLocation v-else :bodypart="bodypart" :choice="model" v-on:addvalue="value => $emit('action', value)" v-on:goback="showLocation = false; bodypart = null" />
</template>

<script>
import { observer } from "mobx-vue";
import SymptomLocation from './SymptomLocation'
import SymptomLocationFrontFace from './SymptomLocationFrontFace'
import SymptomLocationSideFace from './SymptomLocationSideFace'
import SymptomLocationFrontBody from './SymptomLocationFrontBody'
import SymptomLocationBackBody from './SymptomLocationBackBody'
export default observer({
    name: 'Bodyparts',
    data() {
        return {
            showLocation: false,
            bodypart: null
        }
    },
    props: {
        model: [String, Array],
        preview: Boolean
    },
    components: {
        SymptomLocation, SymptomLocationFrontFace, SymptomLocationSideFace, SymptomLocationFrontBody, SymptomLocationBackBody
    },
    methods: {
        showDetails: function(location) {
            if (this.preview) return
            this.showLocation = true
            this.bodypart = location
        }
    }
})
</script>

<style lang="scss" scoped>
.nettdoc-bodyparts {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-template-rows: 50% 50%;
    grid-gap: 20px;
    padding: 20px;
    padding-bottom: 40px;
    div {
        margin: auto;
        cursor: pointer;
    }
    &__frame {
        padding: 10px;
        border-radius: 4px;
        border: solid 1px var(--light-sky-blue);
        background-color: var(--pale-grey);
    }
    &__is-active {
        background-color: var(--dark-peach) !important;
        padding: 10px;
        border-radius: 5px;
        cursor: pointer;
    }
}
.nettdoc-preview {
    cursor: none !important;
    div {
        cursor: none !important;
    }
    &__is-active {
        cursor: none !important;
    }
}
</style>